import ContentWrapper from "@/components/Core/ContentWrapper";
import ThreeJSAboutVideoAnimation from "@/components/ThreeJSVideoAnimation";
import styled from "styled-components";

export default function AboutTimelineComponent() {
  return (
    <ContentWrapper backgroundColor='#08090A'>
      <ThreeJSAboutVideoAnimation />
    </ContentWrapper>
  );
}
